import { useEffect, useRef, useState } from 'react';
import { useFetchWrapper } from '../_helpers/fetchWrapper.js';
import config from '../config.js';

const list = (value) => (Array.isArray(value) ? value : []);

/** The detail payload in the shape the song page reads. */
export const normalizeSongDetail = (raw) => ({
  id: raw.id,
  title: raw.title ?? '',
  artist: raw.artist ?? '',
  artworkUrl: raw.artwork_url || '',
  album: raw.album || '',
  releaseYear: raw.release_year || null,
  writtenBy: raw.written_by || '',
  genres: list(raw.genres),
  moods: list(raw.moods),
  tags: list(raw.tags).map((tag) => ({ id: tag.id, word: tag.word ?? '' })),
  playedTonight: Boolean(raw.played_tonight),
  repeatBlocked: Boolean(raw.repeat_blocked),
});

/**
 * One crate song for the song page (mockup 22, ENG-709) from
 * `GET /public/bands/{id}/songs/{songId}` (ENG-710). `status` is loading,
 * ready, missing (the band no longer lists it) or failed.
 */
export const useSongDetail = (bandId, songId) => {
  const fetchWrapperRef = useRef(useFetchWrapper());
  const [state, setState] = useState({ status: 'loading', song: null });

  useEffect(() => {
    if (!bandId || !songId) return undefined;
    let cancelled = false;
    setState({ status: 'loading', song: null });
    fetchWrapperRef.current
      .get(`${config.apiBaseUrl}/public/bands/${bandId}/songs/${songId}`)
      .then((answer) => {
        if (!cancelled) setState({ status: 'ready', song: normalizeSongDetail(answer ?? {}) });
      })
      .catch((err) => {
        if (!cancelled) setState({ status: err?.status === 404 ? 'missing' : 'failed', song: null });
      });
    return () => { cancelled = true; };
  }, [bandId, songId]);

  return state;
};
